import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Loader2 } from 'lucide-react';

const COUNTING_METHODS = [
  { value: 'paper', label: 'Paper' },
  { value: 'laptop', label: 'Laptop' },
  { value: 'tablet', label: 'Tablet' },
  { value: 'hybrid', label: 'Hybrid' },
];

export default function StocktakeSettingsPanel({ form, onChange, loading }) {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12" data-testid="stocktake-settings-loading">
        <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
        <span className="ml-2 text-sm text-muted-foreground">Loading stocktake settings...</span>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="stocktake-settings-panel">
      {/* Counting */}
      <div className="space-y-2">
        <Label>Default Counting Method</Label>
        <Select
          value={form.default_counting_method || 'not_set'}
          onValueChange={(v) => onChange({ ...form, default_counting_method: v === 'not_set' ? '' : v })}
        >
          <SelectTrigger data-testid="stocktake-counting-method">
            <SelectValue placeholder="Select method..." />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="not_set">Not Set</SelectItem>
            {COUNTING_METHODS.map(m => (
              <SelectItem key={m.value} value={m.value}>{m.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">Default method used when creating new stocktake sessions</p>
      </div>

      {/* Valuation */}
      <div className="space-y-2">
        <Label>Allow Roll Back / Roll Forward Valuations</Label>
        <div className="flex items-center gap-3">
          <Switch
            checked={form.allow_roll_back_forward_valuations || false}
            onCheckedChange={(checked) => onChange({ ...form, allow_roll_back_forward_valuations: checked })}
            data-testid="stocktake-allow-rollback"
          />
          <span className={`text-sm ${form.allow_roll_back_forward_valuations ? 'text-green-600' : 'text-muted-foreground'}`}>
            {form.allow_roll_back_forward_valuations ? 'Enabled' : 'Disabled'}
          </span>
        </div>
        <p className="text-xs text-muted-foreground">When enabled, allows rolling stock values between periods</p>
      </div>

      {/* Sheet Defaults */}
      <div className="space-y-2">
        <Label htmlFor="sheet-sort">Default Stock Forward Sheet Sort / Order</Label>
        <Input
          id="sheet-sort"
          value={form.default_stock_forward_sheet_sort_order || ''}
          onChange={(e) => onChange({ ...form, default_stock_forward_sheet_sort_order: e.target.value })}
          placeholder="e.g. alphabetical, by-location, custom"
          data-testid="stocktake-sheet-sort"
        />
        <p className="text-xs text-muted-foreground">Determines default ordering of items on stock forward sheets</p>
      </div>
    </div>
  );
}
